import { useEffect } from "react";

import { datadogRum } from "@datadog/browser-rum";

type UseDatadogContextProps = typeof datadogRum.setGlobalContextProperty;

export const useDatadogContext: UseDatadogContextProps = (key, property) => {
  useEffect(() => {
    datadogRum.setGlobalContext({ key: property });
    return (): void => {
      datadogRum.removeGlobalContextProperty(key);
    };
  }, [key, property]);
};
